module.exports = __webpack_public_path__ + "static/portfolio-3-46d0cdf15bdc8ab8121a7da85efcd4be.jpg";